/**
 * Comprehensive Phrases Data - Middle School Grade 8
 * 初中八年级短语集合
 *
 * 包含初中进阶表达，约50个短语
 */

import { Phrase } from './phrases-types';

export const middleSchoolGrade8Phrases: Phrase[] = [
  // ==================== 动词短语 Verb Phrases ====================

  {
    id: 'ms8_give_up',
    phrase: 'give up',
    phonetic: '/ɡɪv ʌp/',
    meaning: '放弃',
    usageScenario: '描述放弃做某事或停止尝试',
    example: 'Never give up your dreams.',
    exampleTranslation: '永远不要放弃你的梦想。',
    category: 'actions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_put_off',
    phrase: 'put off',
    phonetic: '/pʊt ɒf/',
    meaning: '推迟',
    usageScenario: '描述延期做某事',
    example: 'The meeting was put off.',
    exampleTranslation: '会议被推迟了。',
    category: 'actions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_put_on',
    phrase: 'put on',
    phonetic: '/pʊt ɒn/',
    meaning: '穿上/戴上',
    usageScenario: '描述穿戴衣物、眼镜等',
    example: 'Put on your coat. It\'s cold.',
    exampleTranslation: '穿上你的外套。很冷。',
    category: 'actions',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_take_off',
    phrase: 'take off',
    phonetic: '/teɪk ɒf/',
    meaning: '脱下/起飞',
    usageScenario: '描述脱下衣物或飞机起飞',
    example: 'Take off your shoes.',
    exampleTranslation: '脱下你的鞋子。',
    category: 'actions',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_turn_down',
    phrase: 'turn down',
    phonetic: '/tɜːrn daʊn/',
    meaning: '拒绝/调低',
    usageScenario: '描述拒绝请求或调低音量',
    example: 'He turned down my invitation.',
    exampleTranslation: '他拒绝了我的邀请。',
    category: 'actions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_turn_up',
    phrase: 'turn up',
    phonetic: '/tɜːrn ʌp/',
    meaning: '出现/调高',
    usageScenario: '描述出现或调高音量',
    example: 'He turned up late.',
    exampleTranslation: '他迟到了。',
    category: 'actions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_work_out',
    phrase: 'work out',
    phonetic: '/wɜːrk aʊt/',
    meaning: '锻炼/解决',
    usageScenario: '描述健身或解决问题',
    example: 'I work out every day.',
    exampleTranslation: '我每天锻炼。',
    category: 'actions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_break_down',
    phrase: 'break down',
    phonetic: '/breɪk daʊn/',
    meaning: '出故障/崩溃',
    usageScenario: '描述机器故障或情绪崩溃',
    example: 'My car broke down.',
    exampleTranslation: '我的车坏了。',
    category: 'actions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_get_over',
    phrase: 'get over',
    phonetic: '/ɡet ˈoʊvər/',
    meaning: '克服/恢复',
    usageScenario: '描述克服困难或从疾病中恢复',
    example: 'You must get over your fear.',
    exampleTranslation: '你必须克服你的恐惧。',
    category: 'actions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_run_out_of',
    phrase: 'run out of',
    phonetic: '/rʌn aʊt əv/',
    meaning: '用完',
    usageScenario: '描述耗尽某种资源',
    example: 'We ran out of water.',
    exampleTranslation: '我们用完了水。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },

  // ==================== 其他常用短语 Common Phrases ====================

  {
    id: 'ms8_be_proud_of',
    phrase: 'be proud of',
    phonetic: '/biː praʊd əv/',
    meaning: '为……感到骄傲',
    usageScenario: '表达对某人或某事的自豪',
    example: 'I am proud of my son.',
    exampleTranslation: '我为我的儿子感到骄傲。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_afraid_of',
    phrase: 'be afraid of',
    phonetic: '/biː əˈfreɪd əv/',
    meaning: '害怕',
    usageScenario: '表达恐惧或担心',
    example: 'I am afraid of dogs.',
    exampleTranslation: '我害怕狗。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_good_at',
    phrase: 'be good at',
    phonetic: '/biː ɡʊd æt/',
    meaning: '擅长',
    usageScenario: '描述某人的长处或技能',
    example: 'She is good at English.',
    exampleTranslation: '她擅长英语。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_interested_in',
    phrase: 'be interested in',
    phonetic: '/biː ˈɪntrəstɪd ɪn/',
    meaning: '对……感兴趣',
    usageScenario: '表达兴趣或关注',
    example: 'I am interested in music.',
    exampleTranslation: '我对音乐感兴趣。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_famous_for',
    phrase: 'be famous for',
    phonetic: '/biː ˈfeɪməs fɔːr/',
    meaning: '因……而闻名',
    usageScenario: '描述某人或某地因何而出名',
    example: 'Beijing is famous for the Great Wall.',
    exampleTranslation: '北京因长城而闻名。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_worried_about',
    phrase: 'be worried about',
    phonetic: '/biː ˈwɜːrid əˈbaʊt/',
    meaning: '担心',
    usageScenario: '表达忧虑或担心',
    example: 'I am worried about the exam.',
    exampleTranslation: '我担心考试。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_excited_about',
    phrase: 'be excited about',
    phonetic: '/biː ɪkˈsaɪtɪd əˈbaʊt/',
    meaning: '对……感到兴奋',
    usageScenario: '表达兴奋或期待',
    example: 'I am excited about the trip.',
    exampleTranslation: '我对这次旅行感到兴奋。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_surprised_at',
    phrase: 'be surprised at',
    phonetic: '/biː sərˈpraɪzd æt/',
    meaning: '对……感到惊讶',
    usageScenario: '表达惊讶或意外',
    example: 'I was surprised at the news.',
    exampleTranslation: '我对这个消息感到惊讶。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_be_different_from',
    phrase: 'be different from',
    phonetic: '/biː ˈdɪfrənt frɒm/',
    meaning: '与……不同',
    usageScenario: '比较事物的差异',
    example: 'This book is different from that one.',
    exampleTranslation: '这本书与那本不同。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_be_similar_to',
    phrase: 'be similar to',
    phonetic: '/biː ˈsɪmɪlər tuː/',
    meaning: '与……相似',
    usageScenario: '比较事物的相似性',
    example: 'This problem is similar to that one.',
    exampleTranslation: '这个问题与那个相似。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },

  // ==================== 时间和频率 Time and Frequency ====================

  {
    id: 'ms8_away_from',
    phrase: 'away from',
    phonetic: '/əˈweɪ frɒm/',
    meaning: '远离',
    usageScenario: '描述距离或分离',
    example: 'Stay away from the fire.',
    exampleTranslation: '远离火源。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_right_now',
    phrase: 'right now',
    phonetic: '/raɪt naʊ/',
    meaning: '立刻/现在',
    usageScenario: '强调当前时刻',
    example: 'I need your help right now.',
    exampleTranslation: '我现在就需要你的帮助。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_right_away',
    phrase: 'right away',
    phonetic: '/raɪt əˈweɪ/',
    meaning: '立刻',
    usageScenario: '强调立即行动',
    example: 'Come here right away.',
    exampleTranslation: '立刻过来。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_at_present',
    phrase: 'at present',
    phonetic: '/æt ˈpreznt/',
    meaning: '目前',
    usageScenario: '描述当前状态',
    example: 'At present, I am busy.',
    exampleTranslation: '目前我很忙。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_in_the_past',
    phrase: 'in the past',
    phonetic: '/ɪn ðə pæst/',
    meaning: '在过去',
    usageScenario: '描述过去的时间',
    example: 'In the past, people lived differently.',
    exampleTranslation: '在过去，人们的生活方式不同。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_in_the_future',
    phrase: 'in the future',
    phonetic: '/ɪn ðə ˈfjuːtʃər/',
    meaning: '在未来',
    usageScenario: '描述未来的时间',
    example: 'I want to be a doctor in the future.',
    exampleTranslation: '未来我想当一名医生。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_from_now_on',
    phrase: 'from now on',
    phonetic: '/frɒm naʊ ɒn/',
    meaning: '从现在开始',
    usageScenario: '描述新的开始或决定',
    example: 'From now on, I will study hard.',
    exampleTranslation: '从现在开始，我会努力学习。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_day_by_day',
    phrase: 'day by day',
    phonetic: '/deɪ baɪ deɪ/',
    meaning: '一天天',
    usageScenario: '描述渐进的变化',
    example: 'He is getting better day by day.',
    exampleTranslation: '他一天天在好转。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },

  // ==================== 其他常用表达 Other Expressions ====================

  {
    id: 'ms8_all_of_a_sudden',
    phrase: 'all of a sudden',
    phonetic: '/ɔːl əv ə ˈsʌdn/',
    meaning: '突然',
    usageScenario: '描述突然发生的事',
    example: 'All of a sudden, it rained.',
    exampleTranslation: '突然下雨了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_to_ones_surprise',
    phrase: 'to one\'s surprise',
    phonetic: '/tuː wʌnz sərˈpraɪz/',
    meaning: '令某人惊讶的是',
    usageScenario: '表达意外的结果',
    example: 'To my surprise, he passed the exam.',
    exampleTranslation: '令我惊讶的是，他通过了考试。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_in_other_words',
    phrase: 'in other words',
    phonetic: '/ɪn ˈʌðər wɜːrdz/',
    meaning: '换句话说',
    usageScenario: '解释或重新表达',
    example: 'In other words, you are wrong.',
    exampleTranslation: '换句话说，你错了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_on_the_other_hand',
    phrase: 'on the other hand',
    phonetic: '/ɒn ði ˈʌðər hænd/',
    meaning: '另一方面',
    usageScenario: '对比或转折',
    example: 'On the other hand, it has some advantages.',
    exampleTranslation: '另一方面，它也有一些优点。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_by_oneself',
    phrase: 'by oneself',
    phonetic: '/baɪ wʌnˈself/',
    meaning: '独自地',
    usageScenario: '描述独自做某事',
    example: 'I can do it by myself.',
    exampleTranslation: '我可以独自完成。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_for_oneself',
    phrase: 'for oneself',
    phonetic: '/fɔːr wʌnˈself/',
    meaning: '为自己',
    usageScenario: '描述为自己做事',
    example: 'You should decide for yourself.',
    exampleTranslation: '你应该自己决定。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_of_course_not',
    phrase: 'of course not',
    phonetic: '/əv kɔːrs nɒt/',
    meaning: '当然不',
    usageScenario: '否定回答',
    example: 'Are you tired? - Of course not!',
    exampleTranslation: '你累吗？- 当然不！',
    category: 'responses',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_not_at_all',
    phrase: 'not at all',
    phonetic: '/nɒt æt ɔːl/',
    meaning: '一点也不',
    usageScenario: '完全否定',
    example: 'I am not tired at all.',
    exampleTranslation: '我一点也不累。',
    category: 'responses',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_no_matter',
    phrase: 'no matter',
    phonetic: '/noʊ ˈmætər/',
    meaning: '不管/无论',
    usageScenario: '表示无论什么情况',
    example: 'No matter what happens, I will support you.',
    exampleTranslation: '无论发生什么，我都会支持你。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_as_well_as',
    phrase: 'as well as',
    phonetic: '/æz wel æz/',
    meaning: '也/和',
    usageScenario: '连接并列成分',
    example: 'He speaks English as well as Chinese.',
    exampleTranslation: '他说英语也说中文。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_not_only_but_also',
    phrase: 'not only...but also...',
    phonetic: '/nɒt ˈoʊnli bʌt ˈɔːlsoʊ/',
    meaning: '不仅……而且……',
    usageScenario: '强调两个并列成分',
    example: 'He is not only smart but also kind.',
    exampleTranslation: '他不仅聪明而且善良。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_either_or',
    phrase: 'either...or...',
    phonetic: '/ˈiːðər ɔːr/',
    meaning: '或者……或者……',
    usageScenario: '表示选择',
    example: 'You can either stay or leave.',
    exampleTranslation: '你可以留下或者离开。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_neither_nor',
    phrase: 'neither...nor...',
    phonetic: '/ˈniːðər nɔːr/',
    meaning: '既不……也不……',
    usageScenario: '表示两者都不',
    example: 'He is neither tall nor short.',
    exampleTranslation: '他既不高也不矮。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms8_both_and',
    phrase: 'both...and...',
    phonetic: '/boʊθ ænd/',
    meaning: '两者都',
    usageScenario: '表示两者都',
    example: 'Both Tom and Jack are students.',
    exampleTranslation: 'Tom和Jack都是学生。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_so_far',
    phrase: 'so far',
    phonetic: '/soʊ fɑːr/',
    meaning: '到目前为止',
    usageScenario: '描述到目前的状态',
    example: 'So far, everything is fine.',
    exampleTranslation: '到目前为止，一切都好。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_up_to',
    phrase: 'up to',
    phonetic: '/ʌp tuː/',
    meaning: '多达/取决于',
    usageScenario: '描述数量或责任',
    example: 'It\'s up to you.',
    exampleTranslation: '由你决定。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_too_to',
    phrase: 'too...to...',
    phonetic: '/tuː tuː/',
    meaning: '太……以至于不能……',
    usageScenario: '描述程度过深导致的结果',
    example: 'He is too young to drive.',
    exampleTranslation: '他太年轻了，不能开车。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_enough_to',
    phrase: 'enough...to...',
    phonetic: '/ɪˈnʌf tuː/',
    meaning: '足够……以至于能……',
    usageScenario: '描述达到某种程度',
    example: 'He is old enough to go to school.',
    exampleTranslation: '他足够大，可以上学了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_so_that',
    phrase: 'so...that...',
    phonetic: '/soʊ ðæt/',
    meaning: '如此……以至于……',
    usageScenario: '描述程度导致的结果',
    example: 'He is so tired that he can\'t walk.',
    exampleTranslation: '他太累了，以至于走不动了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms8_such_that',
    phrase: 'such...that...',
    phonetic: '/sʌtʃ ðæt/',
    meaning: '如此……以至于……',
    usageScenario: '描述程度导致的结果（修饰名词）',
    example: 'It was such a good movie that I watched it twice.',
    exampleTranslation: '这部电影太好了，我看了两遍。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
];